import { render } from "./ReportBuilderList.vue?vue&type=template&id=442481d8&scoped=true"
import script from "./ReportBuilderList.vue?vue&type=script&lang=js"
export * from "./ReportBuilderList.vue?vue&type=script&lang=js"

import "./ReportBuilderList.vue?vue&type=style&index=0&id=442481d8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442481d8"]])

export default __exports__